import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IndexComponent } from './components/index/index.component';
import { LanguageComponent } from './components/language/language.component';
import { ReligionBranchTypeComponent } from './components/religion-branch-type/religion-branch-type.component';
import { ReligionBranchComponent } from './components/religion-branch/religion-branch.component';
import { VestmentColorComponent } from './components/vestment-color/vestment-color.component';
import { ProperComponent } from './components/proper/proper.component';
import { SeasonComponent } from './components/season/season.component';
import { LiturgyTypeComponent } from './components/liturgy-type/liturgy-type.component';
import { UserManagementComponent } from './components/user-management/user-management.component';

import { CanActivateViaAuthGuard } from '../../guards/activateGuard';
import { LanguageStyleComponent } from 'app/modules/admin/components/language-style/language-style.component';
import { LectionaryItemTypeComponent } from 'app/modules/admin/components/lectionary-item-type/lectionary-item-type.component';
import { LectionaryItemComponent } from 'app/modules/admin/components/lectionary-item/lectionary-item.component';
import {LectionaryItemNameComponent } from 'app/modules/admin/components/lectionary-item-name/lectionary-item-name.component';
import { LectionarySourceComponent } from 'app/modules/admin/components/lectionary-source/lectionary-source.component';
import { LectionaryTrackComponent } from 'app/modules/admin/components/lectionary-track/lectionary-track.component';
import { LectionaryYearComponent } from 'app/modules/admin/components/lectionary-year/lectionary-year.component';
import { ServiceComponent } from 'app/modules/admin/components/service/service.component';
import { ServiceDateTypeComponent } from 'app/modules/admin/components/service-date-type/service-date-type.component'; 
import { AdminGuard } from 'app/guards/adminGuard';
import { BibleBookComponent } from './components/bible-book/bible-book.component';
import { FeastTypeComponent } from './components/feast-type/feast-type.component';
import { CalendarItemComponent } from './components/calendar-item/calendar-item.component';
import { CssComponent } from './components/css/css.component';
import { PsalterComponent } from './components/psalter/psalter.component';
import { PronunciationComponent } from './components/pronunciation/pronunciation.component';
import { LectionaryItemNameValidateComponent } from './components/lectionary-item-name-validate/lectionary-item-name-validate.component';
import { ClearCacheComponent } from './components/clear-cache/clear-cache.component';
import { LiturgyTypeLectionaryItemTypeDisplayOrderComponent } from './components/liturgy-type-lectionary-item-type-display-order/liturgy-type-lectionary-item-type-display-order.component';

const childRoutes: Routes = [
  { path: 'adminXXXXXXXX',  component: IndexComponent },
  { path: '',  component: IndexComponent },
  { path: 'bible-book',  component: BibleBookComponent },
  { path: 'calendar-item',  component: CalendarItemComponent },
  { path: 'css', component: CssComponent },
  { path: 'feast-type', component: FeastTypeComponent },
  { path: 'language-style', component: LanguageStyleComponent },
  { path: 'languages',  component: LanguageComponent },
  { path: 'liturgy-type',  component: LiturgyTypeComponent }, 
  { path: 'lectionary-item', component: LectionaryItemComponent },
  { path: 'lectionary-item/:id', component: LectionaryItemComponent },
  { path: 'lectionary-item-type', component: LectionaryItemTypeComponent },
  { path: 'lectionary-item-name', component: LectionaryItemNameComponent },
  { path: 'lectionary-item-name-validate', component: LectionaryItemNameValidateComponent },
  { path: 'lectionary-source', component: LectionarySourceComponent },
  { path: 'lectionary-track', component: LectionaryTrackComponent },
  { path: 'lectionary-year', component: LectionaryYearComponent },
  { path: 'liturgy-type-lectionary-item-type-display-order', component: LiturgyTypeLectionaryItemTypeDisplayOrderComponent },
  { path: 'religion-branch',  component: ReligionBranchComponent },
  { path: 'religion-branch-type',  component: ReligionBranchTypeComponent },
  { path: 'vestment-color',  component: VestmentColorComponent },
  { path: 'psalter',  component: PsalterComponent },
  { path: 'proper',  component: ProperComponent },
  { path: 'pronunciation',  component: PronunciationComponent },
  { path: 'season',  component: SeasonComponent },
  { path: 'service', component: ServiceComponent }, 
  { path: 'service-date-type', component: ServiceDateTypeComponent },
  { path: 'user-management', component: UserManagementComponent },
  { path: 'clear-cache', component: ClearCacheComponent },
  { path: 'db-status-report', loadChildren: () => import('../db-status-reports/db-status-reports.module').then(m=>m.DbStatusReportsModule) },
] 

const guardedRoute = [ 
  { path:'admin', canActivate: [CanActivateViaAuthGuard], children: childRoutes}
] 

@NgModule({
    imports : [RouterModule.forRoot(guardedRoute)],
    exports: [ RouterModule],
    providers: [ CanActivateViaAuthGuard, AdminGuard ]
})

export class AdminRoutingModule {}
